var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTablerCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 87,
    viewBox: "0 0 87 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 43.5C10.875 47.7844 11.7189 52.0268 13.3584 55.985C14.998 59.9433 17.4011 63.5398 20.4306 66.5694C23.4602 69.5989 27.0567 72.002 31.015 73.6416C34.9732 75.2811 39.2156 76.125 43.5 76.125C47.7844 76.125 52.0268 75.2811 55.985 73.6416C59.9433 72.002 63.5398 69.5989 66.5694 66.5694C69.5989 63.5398 72.002 59.9433 73.6416 55.985C75.2811 52.0268 76.125 47.7844 76.125 43.5C76.125 39.2156 75.2811 34.9732 73.6416 31.015C72.002 27.0567 69.5989 23.4602 66.5694 20.4306C63.5398 17.4011 59.9433 14.998 55.985 13.3584C52.0268 11.7189 47.7844 10.875 43.5 10.875C39.2156 10.875 34.9732 11.7189 31.015 13.3584C27.0567 14.998 23.4602 17.4011 20.4306 20.4306C17.4011 23.4602 14.998 27.0567 13.3584 31.015C11.7189 34.9732 10.875 39.2156 10.875 43.5Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.65 32.625C52.9933 31.4859 52.0392 30.5468 50.8899 29.9083C49.7405 29.2697 48.4391 28.9558 47.125 29H39.875C37.9522 29 36.1081 29.7638 34.7485 31.1235C33.3888 32.4831 32.625 34.3272 32.625 36.25C32.625 38.1728 33.3888 40.0169 34.7485 41.3765C36.1081 42.7362 37.9522 43.5 39.875 43.5H47.125C49.0478 43.5 50.8919 44.2638 52.2515 45.6235C53.6112 46.9831 54.375 48.8272 54.375 50.75C54.375 52.6728 53.6112 54.5169 52.2515 55.8765C50.8919 57.2362 49.0478 58 47.125 58H39.875C38.5609 58.0442 37.2595 57.7303 36.1101 57.0917C34.9608 56.4532 34.0067 55.5141 33.35 54.375M43.5 25.375V61.625",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTablerCoin);
export default __webpack_public_path__ + "static/media/tabler_coin.1ef71b534d926fb5d4a4b6645ed06d7e.svg";
export { ForwardRef as ReactComponent };